// frontend/src/theme/components/menu.js
// Standardize edilmiş Menu bileşeni - dock stili ile uyumlu
// Faz 4.1 · Hardcoded hex'ler semantic token'lara migre edildi.
// Renk korumasi: '#252837' (dark menu bg) -> 'slate.750' (#262D34, 1px farkla aynı).
// Diger tum hex'ler mevcut semantic token'lara birebir esleniyor.

const Menu = {
  baseStyle: {
    list: {
      bg: 'menuBg',
      borderColor: 'borderPrimary',
      borderWidth: '1px',
      borderRadius: 'xl',
      boxShadow: 'menuShadow',
      py: 2,
      overflow: 'hidden',
      backdropFilter: 'saturate(180%) blur(26px)',
      WebkitBackdropFilter: 'saturate(180%) blur(26px)',
      zIndex: 'popover',
      // Modern giriş animasyonu
      animation: 'menuSlideIn var(--motion-duration-base) var(--motion-ease-apple)',
      transformOrigin: 'top',
      '@keyframes menuSlideIn': {
        from: {
          opacity: 0,
          transform: 'translateY(-8px) scale(0.96)',
        },
        to: {
          opacity: 1,
          transform: 'translateY(0) scale(1)',
        },
      },
      // Scrollbar stilleri
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'menuScrollbarThumb',
        borderRadius: 'full',
        transition: 'background var(--motion-duration-fast) var(--motion-ease-apple)',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: 'menuScrollbarThumbHover',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
    },
    item: {
      bg: 'transparent',
      color: 'textPrimary',
      fontSize: 'sm',
      fontWeight: 'medium',
      py: 2.5,
      px: 4,
      mx: 1.5,
      borderRadius: 'lg',
      transition: 'all var(--motion-duration-fast) var(--motion-ease-apple)',
      _hover: {
        bg: 'menuItemHoverBg',
        color: 'textPrimary',
      },
      _focus: {
        bg: 'menuItemHoverBg',
        boxShadow: 'none',
      },
      _active: {
        bg: 'menuItemActiveBg',
        transform: 'scale(0.98)',
      },
      // İkon ve metin hizalama
      '& > svg, & > span > svg': {
        marginRight: '12px',
        opacity: 0.8,
        transition: 'opacity var(--motion-duration-fast) var(--motion-ease-apple)',
      },
      '_hover > svg, _hover > span > svg': {
        opacity: 1,
      },
    },
    groupTitle: {
      color: 'textMuted',
      fontSize: 'xs',
      fontWeight: 'semibold',
      textTransform: 'uppercase',
      letterSpacing: 'uppercase',
      px: 4,
      py: 2,
    },
    divider: {
      borderColor: 'borderPrimary',
      my: 1.5,
      mx: 2,
      opacity: 0.8,
    },
    button: {
      transition: 'all var(--motion-duration-fast) var(--motion-ease-apple)',
    },
    command: {
      color: 'textMuted',
      fontSize: 'xs',
      opacity: 0.7,
    },
  },
  variants: {
    // Dock ile uyumlu kompakt versiyon (mobile bottom sheet)
    'dock': {
      list: {
        bg: 'menuBg',
        borderColor: 'borderPrimary',
        borderWidth: '1px',
        borderRadius: '2xl',
        borderBottomRadius: { base: 0, md: '2xl' },
        boxShadow: 'menuShadowUp',
        py: 1,
        backdropFilter: 'saturate(180%) blur(26px)',
        WebkitBackdropFilter: 'saturate(180%) blur(26px)',
        maxH: { base: '70vh', md: '80vh' },
        overflowY: 'auto',
        animation: 'dockSlideUp var(--motion-duration-base) var(--motion-ease-apple)',
        transformOrigin: 'bottom',
        '@keyframes dockSlideUp': {
          from: {
            opacity: 0,
            transform: 'translateY(16px) scale(0.95)',
          },
          to: {
            opacity: 1,
            transform: 'translateY(0) scale(1)',
          },
        },
      },
      item: {
        bg: 'transparent',
        color: 'textPrimary',
        fontSize: { base: 'sm', md: 'md' },
        fontWeight: 'medium',
        py: { base: 3, md: 2.5 },
        px: { base: 4, md: 4 },
        mx: { base: 2, md: 1.5 },
        borderRadius: 'xl',
        transition: 'all var(--motion-duration-fast) var(--motion-ease-apple)',
        _hover: {
          bg: 'menuItemHoverBg',
        },
        _active: {
          bg: 'menuItemActiveBg',
          transform: 'scale(0.98)',
        },
      },
    },
    // Bildirim menüsü için özel stil
    'notification': {
      list: {
        bg: 'menuBg',
        borderColor: 'borderPrimary',
        borderWidth: '1px',
        borderRadius: 'xl',
        boxShadow: 'menuShadowStrong',
        py: 0,
        overflow: 'hidden',
        backdropFilter: 'saturate(180%) blur(26px)',
        WebkitBackdropFilter: 'saturate(180%) blur(26px)',
        maxH: { base: '75vh', md: '80vh' },
        overflowY: 'auto',
        animation: 'menuSlideIn var(--motion-duration-base) var(--motion-ease-apple)',
        transformOrigin: 'top right',
      },
      item: {
        bg: 'transparent',
        color: 'textPrimary',
        fontSize: { base: 'xs', md: 'sm' },
        py: { base: 2.5, md: 3 },
        px: { base: 3, md: 4 },
        mx: 0,
        borderRadius: 0,
        borderBottomWidth: '1px',
        borderColor: 'borderSecondary',
        transition: 'all var(--motion-duration-fast) var(--motion-ease-apple)',
        _hover: {
          bg: 'menuItemHoverBgSubtle',
        },
        _last: {
          borderBottomWidth: 0,
        },
      },
    },
    // Avatar/Profile menüsü için
    'profile': {
      list: {
        bg: 'menuBg',
        borderColor: 'borderPrimary',
        borderWidth: '1px',
        borderRadius: 'xl',
        boxShadow: 'menuShadow',
        py: 2,
        overflow: 'hidden',
        backdropFilter: 'saturate(180%) blur(26px)',
        WebkitBackdropFilter: 'saturate(180%) blur(26px)',
        minW: { base: '260px', md: '280px' },
        animation: 'menuSlideIn var(--motion-duration-base) var(--motion-ease-apple)',
        transformOrigin: 'top right',
      },
      item: {
        bg: 'transparent',
        color: 'textPrimary',
        fontSize: 'sm',
        fontWeight: 'medium',
        py: 2.5,
        px: 4,
        mx: 1.5,
        borderRadius: 'lg',
        transition: 'all var(--motion-duration-fast) var(--motion-ease-apple)',
        _hover: {
          bg: 'menuItemHoverBg',
          color: 'textPrimary',
        },
        _active: {
          bg: 'menuItemActiveBg',
          transform: 'scale(0.98)',
        },
      },
    },
  },
  defaultProps: {},
};

export default Menu;
